import React, { useContext } from 'react';
import { MenuContext } from '../../context';
import NewWindow from '../../assets/new_window.inline.svg';
import ExternalLink from '../external-link/external-link.component';

const STICKY_BUTTONS = [
  {
    linkText: "Our latest service levels",
    linkUrl: "/our-latest-service-levels",
    additionalClass: "sticky-buttons__item--red",
    isExternal: true,
  },
  {
    linkText: "Chat with us",
    linkUrl: "https://www.hsbc.co.uk/mortgages/intermediaries/help/",
    isExternal: true,
  },
];

const StickyButtons = () => {
  const menuContext = useContext(MenuContext);

  return (
    <div className="sticky-buttons">
      {STICKY_BUTTONS.map(stickyButton =>
        <ExternalLink to={stickyButton.linkUrl}
                      className={`sticky-buttons__item ${stickyButton.additionalClass || ""}`}
                      target='_blank'
                      inert={menuContext.isMenuOpen ? 'true' : null}
        >
          {stickyButton.linkText}
          {stickyButton.isExternal && <NewWindow />}
        </ExternalLink>
      )}
    </div>
  );
};

export default StickyButtons;